import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import HomeActionCard from '.././components/HomeActionCard';
import { faMagnifyingGlassDollar, faUserPen, faCircleQuestion, faInbox, faScrewdriverWrench, faMapLocationDot, faRectangleList } from '@fortawesome/free-solid-svg-icons';
import '../styles/Home.css';
import RoleUtils from '../utils/roleUtils.js';
import CommonUtils from '../utils/siteUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import RequestUtils from "../utils/requestUtils";

export class Home extends React.Component {   
    constructor(props) {
        super(props)
        this.showAttestModal = this.showAttestModal.bind(this);       

        this.state = {
            showAttest: false,
           
        };
    }
    getActionCards = () => {
        return ([{
            icon: faMagnifyingGlassDollar,
            link: "/Search",
            title: "Invoices/Payments",
            description: "Search for Invoices and Payments Information",
            permissionRoles: RoleUtils.inquiryPerms()
        },
        {
            icon: faUserPen,
            link: "/Profile/Supplier/Access",
            title: "Portal Access",
            description: "Update and Maintain User Access Roles",
            permissionRoles: RoleUtils.editOnly()
        },
        {
            icon: faMapLocationDot,
            link: "/Profile/Supplier",
            title: "Supplier Profile",
            description: "Update and Maintain Supplier Profile Attributes",
            permissionRoles: RoleUtils.profileRoles()
        },
        {
            icon: faRectangleList,
            link: "/Worklist",
            title: "Worklist",
            description: "Review and Maintain Change Requests",
            permissionRoles: RoleUtils.worklistPageAccessRoles()
        },
        {
            icon: faCircleQuestion,
            link: "/Resources",
            title: "Resources",
            description: "FAQ and Support",
            permissionRoles: RoleUtils.allPerms()
        },
        {
            icon: faInbox,
            link: "/Inbox",
            title: "Contact Us",
            description: "Send and Receive Secure Messages",
            permissionRoles: RoleUtils.allPerms()
        },
        {
            icon: faScrewdriverWrench,
            link: "/Admin",
            title: "Administration",
            description: "Update and Maintain Notifications",
            permissionRoles: RoleUtils.optumAdminPerms()
        },

        ]);
    }
    getBaseActionCards = () => {
        return ([{
            icon: faMagnifyingGlassDollar,
            link: "/Search",
            title: "Invoices/Payments",
            description: "Search for Invoices and Payments Information",
            permissionRoles: RoleUtils.inquiryPerms()
        },
        {
            icon: faUserPen,
            link: "/Profile/Supplier/Access",
            title: "Portal Access",
            description: "Update and Maintain User Access Roles",
            permissionRoles: RoleUtils.editOnly()
        },
        {
            icon: faCircleQuestion,
            link: "/Resources",
            title: "Resources",
            description: "FAQ and Support",
            permissionRoles: RoleUtils.allPerms()
        },
        {
            icon: faInbox,
            link: "/Inbox",
            title: "Contact Us",
            description: "Send and Receive Secure Messages",
            permissionRoles: RoleUtils.allPerms()
        },
        {
            icon: faScrewdriverWrench,
            link: "/Admin",
            title: "Administration",
            description: "Update and Maintain Notifications",
            permissionRoles: RoleUtils.optumAdminPerms()
        },

        ]);
    }
    showAttestModal() {
        this.setState({
            showAttest: !this.state.showAttest,
        });
    }

    //submitForm() {
    //    var ewReq = {
    //        "vendorRecordId": 309, //3115,
    //        "vendorBankRequestId": 265, //886,
    //        "earlyWarningRequest": {
    //            "earlyWarningSecondaryId": "",
    //            "clientReference": "",
    //            "transactionChannel": "",
    //            "transactionReason": "",
    //            "bankAccount": {
    //                "routingNumber": "072403473",
    //                "accountNumber": "072403474"
    //            },
    //            //"business": {
    //            //    "name": "CRAZY JIM'S PIZZA",
    //            //    "taxIdNumber": "526354570"
    //            //}
    //            //,
    //            "individual": {
    //                "firstName": "Jim",
    //                "middleName": "L",
    //                "lastName": "Smith",
    //                "nameSuffix": null,
    //                "taxIdNumber": "502904596"
    //            }
    //            ,
    //            "address": { 
    //                "addressLine1": "123 Main Ave",
    //                "addressLine2": null,
    //                "city": "Sioux Falls",
    //                "state": "SD",
    //                "zip": "57105"
    //            }
    //        },
    //        "earlyWarningRequest_Type": 2,
    //    };
    //    ServiceCalls.resubmitEarlyWarningScore(ewReq).then(function (data) {
    //        var errLvl = (data.isSuccessful) ? "info" : "danger";
    //        var msg = (data.isSuccessful) ? "Successfully Updated EW Score" : "Error Updating EW Score";
    //        alert(`Call cameback ${errLvl}  and ${msg}   Full Response: ${JSON.stringify(data)}`);
    //    }).catch(error => {
    //        console.error(`Error in onRequestSubmitEW: ${error}`);
    //    });  
    //}

    render() {
        const { currentUser, currentCompanyId } = this.props;
        var hasWorklistAccess = RoleUtils.determineMaintenanceModeNav(currentUser, currentCompanyId, RoleUtils.worklistPageAccessRoles());;
        var hasProfileAccess = RoleUtils.determineMaintenanceModeNav(currentUser, currentCompanyId, RoleUtils.profileRoles());;
        var actionCards = this.getBaseActionCards();
        if (hasProfileAccess) {
            actionCards.splice(2, 0, {
                icon: faMapLocationDot,
                link: "/Profile/Supplier",
                title: "Supplier Profile",
                description: "Update and Maintain Supplier Profile Attributes",
                permissionRoles: RoleUtils.profileRoles()
            })
        }
        if (hasWorklistAccess) {
            actionCards.splice(3, 0, {
                icon: faRectangleList,
                link: "/Worklist",
                title: "Worklist",
                description: "Review and Maintain Change Requests",
                permissionRoles: RoleUtils.worklistPageAccessRoles()
            });
        }

        
      
        return (
            (currentUser) ?
        <Container fluid>               
              <Row>
                  <Col>
                            <h3 id="homeWelcomeMessage">Welcome to UnitedHealth Group's Payment Services Supplier Portal</h3>
                  </Col>
                    </Row>
                    {/*<Row>*/}
                    {/*    <Col>*/}
                    {/*       <Button key="A" className="vActionBtn right" id="approveBtn" onClick={this.submitForm}>Resubmit</Button>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                    <Row>
                        <Col>
                            <h5 id="homeWelcomeMessage">
                                <span>By using this site you are agreeing to our </span>
                               
                                <span><a href={CommonUtils.generatePrivacyPolicyUrl()} title="View Privacy Policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></span>
                          
                                <span> and </span>
                          
                                <span><a href={CommonUtils.generateTOSUrl("")} title="View Terms of Use" target="_blank" rel="noopener noreferrer">Terms of Use</a></span>

                            </h5>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                {                         
                 actionCards.map(function (card, idx) {
                      return (
                          <HomeActionCard key={idx}currentUser={currentUser} currentCompanyId={currentCompanyId} cardIcon={card.icon} cardLink={card.link} cardTitle={card.title} cardDescription={card.description} cardPermissions={card.permissionRoles} />
                     );
                })
            }
                    </Row>
                 
          </Container>
                :<div>Loading</div>
    );
  }
}
